import { render, staticRenderFns } from "./use-scope.vue?vue&type=template&id=4e257590&scoped=true&"
import script from "./use-scope.vue?vue&type=script&lang=js&"
export * from "./use-scope.vue?vue&type=script&lang=js&"
import style0 from "./use-scope.vue?vue&type=style&index=0&id=4e257590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e257590",
  null
  
)

export default component.exports